var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPushPinOutlined = function SvgPushPinOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2c.55 0 1 .45 1 1s-.45 1-1 1h-1v5c0 1.38.93 2.54 2.2 2.89.46.13.8.51.8.98V13c0 .55-.45 1-1 1h-5.02l.02 7c0 .55-.45 1-1 1s-1-.45-1-1l-.02-7H6c-.55 0-1-.45-1-1v-.13c0-.47.34-.85.8-.98C7.07 11.54 8 10.38 8 9V4H7c-.55 0-1-.45-1-1s.45-1 1-1zm-7 7a4.97 4.97 0 0 1-1.001 3h6.002A4.97 4.97 0 0 1 14 9V4h-4z",
    clipRule: "evenodd"
  })));
};
export default SvgPushPinOutlined;